import firebase from "@firebase/app";
import "@firebase/messaging";
var firebaseConfig = {
    apiKey: "AIzaSyBPc9C3aykMZvf73ZSLrtLXXf3MPAFXxYk",
       authDomain: "brain100studio-a60ee.firebaseapp.com",
       databaseURL: "https://brain100studio-a60ee.firebaseio.com",
       projectId: "brain100studio-a60ee",
       storageBucket: "brain100studio-a60ee.appspot.com",
       messagingSenderId: "948337467952",
       appId: "1:948337467952:web:73c87809c5a681028603f5",
       measurementId: "G-23QBKM0PMR"
   };
   firebase.initializeApp(firebaseConfig);
   let messaging;
   if (firebase.messaging.isSupported()) {
    messaging = firebase.messaging();
   }
   export {firebase,messaging}